import { DirectiveHook, ObjectDirective } from 'vue';

export type Config = {
  hiddenFields?: string[];
}

//v-config-hidden
const configHidden: DirectiveHook<HTMLElement, unknown, { config: Config, key: string }> =
  (el, binding, vnode, oldVnode) => {
    if ((binding.value.config.hiddenFields ?? []).includes(binding.value.key)) {
      el.style.display = 'none';
    }
  };

export default {
  bind: configHidden,
  update: configHidden,
} as ObjectDirective<HTMLElement, { config: Config, key: string }>;
